import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {AuthService} from './common/services/auth.service';
import {Injectable} from '@angular/core';
import {UserService} from '@services/backend/user.service';
import {UserProfile} from '@interfaces/user-profile.interface';

@Injectable()
export class authGuardGuard implements CanActivate {
  constructor(
    private auth: AuthService,
    private userService: UserService,
    private router: Router) {
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    const cookies = document.cookie.split(';').map(cookie => cookie.trim());
    const sessionCookie = cookies.find(cookie => cookie.startsWith('sessionToken='));
    const accessCookie = cookies.find(cookie => cookie.startsWith('accessToken='));
    if (sessionCookie && accessCookie) {
      const token = sessionCookie.split('=')[1];
      const accessToken = accessCookie.split('=')[1];
      if (token && accessToken) {
        let profile: UserProfile = this.userService.userProfile;
        if (!profile) {
          this.auth.idToken = token;
          this.auth.accesToken = accessToken;
          profile = await this.userService.getUser().toPromise() as UserProfile;
        }
        const status: string = profile.enrollment_status;
        if (state.url === '/dashboard' && (status === 'DOCUMENTS_UPLOADED' || status === 'COMPLETED')) {
          this.auth.initInactivityTimer();
          return true;
        }
        return state.url !== '/dashboard';

      } else {
        return this.router.createUrlTree([''])
      }
    } else {
      return this.router.createUrlTree([''])
    }
  }
}
